import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

// global reveal trigger
const reveal = gsap.utils.toArray('.js-trigger-reveal');

reveal.forEach(reveal => {

    // CONTENT REVEAL ANIMATION
    ScrollTrigger.create({
        start: "top bottom-=30%",
        trigger: reveal,
        onEnter: ({progress, direction, isActive}) => reveal.classList.add('revealed'),
        // onLeaveBack: ({progress, direction, isActive}) => reveal.classList.remove('revealed'),
        // markers: {startColor: "blue", endColor: "red", fontSize: "18px", fontWeight: "bold", indent: 20}
    });

});

// Set all to revealed if a jumplink is clicked
document.querySelectorAll('a[href^="#"]').forEach(jumplink => {
    jumplink.addEventListener('click', () => {
        reveal.forEach(reveal => reveal.classList.add('revealed'));
    });
});
